import { Box, Typography, IconButton } from '@mui/material'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import EmailIcon from '@mui/icons-material/Email'

import GitHub from '../assets/images/contact/github_bgp.png'
import LinkedIn from '../assets/images/contact/li_bgp.png'


const Contact = () => {
  return (
    <Box sx={{
      marginTop: '5rem',
      backgroundColor: '#635985',
      width: '100vw',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <div>
        <Typography variant="h4" sx={{ color: '#EDEBF7', textAlign: 'center', mt: 2 }}>
          Contact <strong style={{ fontStyle: 'italic' }}>Me</strong>
        </Typography>

        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '.5rem',
          marginTop: '1.5rem',
          color: '#EDEBF7'
        }}>
          <LocationOnIcon sx={{ color: '#18122B' }}/>
          <Typography variant='body1' sx={{ color: '#EDEBF7' }}>
            Sarajevo, Bosnia and Herzegovina
          </Typography>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '.5rem',
          marginTop: '1rem',
          color: '#EDEBF7'
        }}>

          <EmailIcon sx={{ color: '#18122B' }} />
          <Typography variant='body1' sx={{ color: '#EDEBF7' }}>
            <a href={`mailto:djozo_faruk@hotmail.com`} style={{ color: '#EDEBF7' }}>djozo_faruk@hotmail.com</a>
          </Typography>

        </div>

        <Typography variant='body1' sx={{ color: '#EDEBF7', textAlign: 'center', marginTop: '1rem' }}>
          <strong>Other links</strong>:
        </Typography>

        <Box sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '1rem',
          mb: 1,
          width: '100%',
          justifyContent: 'center'
        }}>
          <IconButton href='https://github.com/farukdozo' target='_blank'>
            <img src={GitHub} width={24} alt='github' />
          </IconButton>
          <IconButton href='https://www.linkedin.com/in/faruk-dozo-492921281/' target='_blank'>
            <img src={LinkedIn} width={24} alt='Linkedin' />
          </IconButton>
        </Box>
      </div>
    </Box>
  )
}

export default Contact